import {
  REACT_APP_MICROSOFT_ENTRA_SSO_ENTITY_ID,
  REACT_APP_MICROSOFT_ENTRA_SSO_CALLBACK_URL,
} from '../../../../constants/envConstants';
import type { SsoProvider } from '../interfaces/sso-configuration.types';
export const SSO_PROVIDERS: {
  label: string;
  value: SsoProvider;
  name: string;
  id?: string | null;
  url?: string | null;
}[] = [
  {
    label: 'Microsoft Entra ID',
    value: 'entra',
    name: 'Microsoft Entra',
    id: REACT_APP_MICROSOFT_ENTRA_SSO_ENTITY_ID,
    url: REACT_APP_MICROSOFT_ENTRA_SSO_CALLBACK_URL,
  },
  /*
  { label: 'Okta', value: 'okta' },
  { label: 'Ping Identity', value: 'ping' },
  { label: 'Google Workspace', value: 'google-workspace' }, */
];

export const SIGNATURE_ALGORITHMS = [
  { label: 'SHA-256 (Recommended)', value: 'sha256' },
  { label: 'SHA-512', value: 'sha512' },
  { label: 'SHA-1 (Legacy)', value: 'sha1' },
];

export const IDENTIFIER_FORMATS = [
  {
    label: 'Email Address (Default)',
    value: 'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress',
  },
  {
    label: 'Persistent',
    value: 'urn:oasis:names:tc:SAML:2.0:nameid-format:persistent',
  },
  {
    label: 'Transient',
    value: 'urn:oasis:names:tc:SAML:2.0:nameid-format:transient',
  },
  {
    label: 'Unspecified',
    value: 'urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified',
  },
];
